import { migration as initial } from "./001_initial";
import { migration as addRegistrationDate } from "./002_add_registration_date";
import { migration as addVehicleCostCenter } from "./003_add_vehicle_cost_center";
import { migration as addRecordExtendedFields } from "./004_add_record_extended_fields";
import { migration as addVendorPartnerIds } from "./005_add_vendor_partner_ids";
import { migration as addMaintenanceWorkflowId } from "./006_add_maintenance_workflow_id";
export const migrations = [
  initial,
  addRegistrationDate,
  addVehicleCostCenter,
  addRecordExtendedFields,
  addVendorPartnerIds,
  addMaintenanceWorkflowId,
];
